import React, { createContext, PureComponent } from 'react';
import { ICardContext } from '../types/CardContext';

interface IProps {
  children: JSX.Element;
}

const initialValue = {
  isCardComponentLoading: true,
  setIsLoading: () => undefined,
  shouldShowCardForm: true,
  setShouldShowCardForm: () => undefined,
  savedInstruments: [],
  setSavedInstruments: () => undefined,
  listExpanded: false,
  setListExpanded: () => undefined,
  selectedToken: undefined,
  setSelectedToken: () => undefined,
};

export const CardContext = createContext<Partial<ICardContext>>(initialValue);

export class CardProvider extends PureComponent<IProps, Partial<ICardContext>> {
  constructor(props: IProps | Readonly<IProps>) {
    super(props);
    this.state = {
      isCardComponentLoading: true,
      shouldShowCardForm: false,
      isSavedInstrumentLoaded: false,
      savedInstruments: [],
      listExpanded: false,
    };
  }

  setIsCardComponentLoading = (isLoading: boolean) => {
    this.setState({ isCardComponentLoading: isLoading });
  };

  setShouldShowCardForm = (shouldShowCardForm: boolean) => {
    this.setState({ shouldShowCardForm });
  };

  setSavedInstruments = (instruments: ISavedInstrument[]) => {
    this.setState({ savedInstruments: instruments, isSavedInstrumentLoaded: true });
  };

  setListExpanded = (expanded: boolean) => {
    this.setState({ listExpanded: expanded });
  };

  setSelectedToken = (token: string | undefined) => {
    this.setState({ selectedToken: token });
  };

  render() {
    const { Provider } = CardContext;
    const { children } = this.props;
    return (
      <Provider
        value={{
          ...this.state,
          setIsCardComponentLoading: this.setIsCardComponentLoading,
          setShouldShowCardForm: this.setShouldShowCardForm,
          setSavedInstruments: this.setSavedInstruments,
          setListExpanded: this.setListExpanded,
          setSelectedToken: this.setSelectedToken,
        }}
      >
        {children}
      </Provider>
    );
  }
}
